import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Booking from "@/pages/Booking";
import Members from "@/pages/Members";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AuthPage from "@/pages/AuthPage";
import AdminMedia from "@/pages/AdminMedia";
import Terms from "@/pages/Terms";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

const ScrollManager = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

const MainLayout = () => (
  <>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <Chatbot />
  </>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AuthProvider>
            <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
              <ScrollManager />
              <Routes>
                <Route element={<MainLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/booking" element={<Booking />} />
                  <Route path="/members" element={<Members />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/admin" element={<AdminMedia />} />
                  <Route path="/conditions" element={<Terms />} />
                  <Route path="/terms" element={<Terms />} />
                </Route>
                <Route path="/login" element={<AuthPage mode="login" />} />
                <Route path="/register" element={<AuthPage mode="register" />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
              <Toaster position="top-center" richColors />
            </ReactLenis>
          </AuthProvider>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
